.wrapper {
  display: flex;
  align-items: start;
  padding: 12px;
  gap: 8px;
  background-color: var(--color-bg-brand-softest);
  color: var(--color-text-primary);
  border-radius: 12px;
  font-size: 15px;
  line-height: 1.3333;
}

.icon {
  padding: 4px;
  border-radius: 9999px;
  width: 1rem;
  height: 1rem;
  margin-block: -2px;
}

.content,
.body {
  min-width: 0;
}

.content {
  display: flex;
  gap: 8px;
  flex-direction: column;
  flex-grow: 1;
}

@media screen and (width >= 630px) {
  .content {
    flex-direction: row;
  }
}

.body {
  flex-grow: 1;
  overflow-wrap: break-word;
  hyphens: auto;

  a {
    color: inherit;
  }

  h3 {
    font-weight: 500;
    margin-bottom: 3px;
  }
}

.actionWrapper {
  display: flex;
  gap: 8px;
  align-items: start;
}

.action {
  appearance: none;
  background: none;
  border: none;
  color: inherit;
  font-weight: 500;
  padding: 0;
  text-wrap: nowrap;
  text-decoration: underline;
  transition: color 0.1s ease-in-out;

  &:hover {
    color: var(--color-text-brand-soft);
  }
}

@media (prefers-reduced-motion: reduce) {
  .action {
    transition: none;
  }
}

.close {
  color: inherit;

  svg {
    width: 20px;
    height: 20px;
  }
}

.variantDefault {
  .icon {
    background-color: var(--color-bg-brand-soft);
  }
}

.variantSubtle {
  border: 1px solid var(--color-border-brand-soft);
  background-color: var(--color-bg-primary);

  .icon {
    background-color: var(--color-bg-brand-softest);
  }
}

.variantFeature {
  background-color: var(--color-bg-brand-base);
  color: var(--color-text-on-brand-base);

  button:hover {
    color: color-mix(var(--color-text-on-brand-base), transparent 20%);
  }
}

.variantInverted {
  background-color: var(--color-bg-inverted);
  color: var(--color-text-inverted);
}

.variantSuccess {
  background-color: var(--color-bg-success-softest);

  .icon {
    background-color: var(--color-bg-success-soft);
  }
}

.variantWarning {
  background-color: var(--color-bg-warning-softest);

  .icon {
    background-color: var(--color-bg-warning-soft);
  }
}

.variantError {
  background-color: var(--color-bg-error-softest);

  .icon {
    background-color: var(--color-bg-error-soft);
  }
}
